// extracted by mini-css-extract-plugin
export default {"OldDeviceModel":"OldDeviceModel_OldDeviceModel__BhheZ"};